import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { setCookie, getCookie } from './cookie'

export async function getFingerPrintId() {
    const fingerprintId = getCookie('fingerprintId');
    console.log('打印当前行情',fingerprintId)
    if (fingerprintId) return fingerprintId;
    debugger
    try {
        const fp = await FingerprintJS.load();
        const result = await fp.get();
        const visitorId = result.visitorId;
        if (visitorId) {
            setCookie('fingerprintId', visitorId);
        }
        return visitorId;
    } catch {
        return '';
    }
}
